import { useState, useCallback } from 'react';
import { useWorkshopProfile } from './useSettings';

const TOTAL_STEPS = 5;

export function useOnboarding() {
  const { profile, updateProfile, isSaving } = useWorkshopProfile();

  const initialStep = profile?.settings.onboarding_step ?? 0;
  const [currentStep, setCurrentStep] = useState(initialStep);

  const isCompleted = profile?.settings.onboarding_completed === true;

  const persistStep = useCallback(
    async (step: number) => {
      await updateProfile({ onboarding_step: step });
    },
    [updateProfile],
  );

  const nextStep = useCallback(async () => {
    const next = Math.min(currentStep + 1, TOTAL_STEPS - 1);
    setCurrentStep(next);
    await persistStep(next);
  }, [currentStep, persistStep]);

  const previousStep = useCallback(async () => {
    const prev = Math.max(currentStep - 1, 0);
    setCurrentStep(prev);
    await persistStep(prev);
  }, [currentStep, persistStep]);

  const skipStep = useCallback(async () => {
    await nextStep();
  }, [nextStep]);

  const completeOnboarding = useCallback(async () => {
    await updateProfile({
      onboarding_completed: true,
      onboarding_step: TOTAL_STEPS - 1,
    });
  }, [updateProfile]);

  return {
    currentStep,
    totalSteps: TOTAL_STEPS,
    isCompleted,
    isSaving,
    profile,
    updateProfile,
    nextStep,
    previousStep,
    skipStep,
    completeOnboarding,
  };
}
